module.exports = __webpack_public_path__ + "img/奖章1级@3x.36e5f2e7.png";